export const FETCH_ACTIVITIES_BEGIN="FETCH_ACTIVITIES_BEGIN";
export const FETCH_ACTIVITIES_SUCCESS="FETCH_ACTIVITIES_SUCCESS";
export const FETCH_ACTIVITIES_FAILURE="FETCH_ACTIVITIES_FAILURE";

export const FETCH_CATEGORY_BEGIN="FETCH_CATEGORY_BEGIN";
export const FETCH_CATEGORY_SUCCESS="FETCH_CATEGORY_SUCCESS";
export const FETCH_CATEGORY_FAILURE="FETCH_CATEGORY_FAILURE";

export const FETCH_ACTIVITYTYPE_BEGIN = "FETCH_ACTIVITYTYPE_BEGIN";
export const FETCH_ACTIVITYTYPE_SUCCESS = "FETCH_ACTIVITYTYPE_SUCCESS";
export const FETCH_ACTIVITYTYPE_FAILURE = "FETCH_ACTIVITYTYPE_FAILURE";

export const FETCH_ACTIVITYENTITYTYPE_BEGIN = "FETCH_ACTIVITYENTITYTYPE_BEGIN";
export const FETCH_ACTIVITYENTITYTYPE_SUCCESS = "FETCH_ACTIVITYENTITYTYPE_SUCCESS";
export const FETCH_ACTIVITYENTITYTYPE_FAILURE = "FETCH_ACTIVITYENTITYTYPE_FAILURE";


export const FETCH_ACTIVITYENTITY_BEGIN = "FETCH_ACTIVITYDETAILS_BEGIN";
export const FETCH_ACTIVITYENTITY_SUCCESS = "FETCH_ACTIVITYDETAILS_SUCCESS";
export const FETCH_ACTIVITYENTITY_FAILURE = "FETCH_ACTIVITYDETAILS_FAILURE";

export const FETCH_ACTIVITYDETAILS_BEGIN = "FETCH_ACTIVITYDETAILS_BEGIN";
export const FETCH_ACTIVITYDETAILS_SUCCESS = "FETCH_ACTIVITYDETAILS_SUCCESS";
export const FETCH_ACTIVITYDETAILS_FAILURE = "FETCH_ACTIVITYDETAILS_FAILURE";

export const FETCH_ACCOUNTORCONTACT_BEGIN = "FETCH_ACCOUNTORCONTACT_BEGIN";
export const FETCH_ACCOUNTORCONTACT_SUCCESS = "FETCH_ACCOUNTORCONTACT_SUCCESS";
export const FETCH_ACCOUNTORCONTACT_FAILURE = "FETCH_ACCOUNTORCONTACT_FAILURE";

